<template>
  <div class="m-box">
    <div class="download-tips" v-if="isWX">
      <p>点击右上角<b>···</b>在浏览器中打开</p>
    </div>
    <div class="downlaod-main">
      <!-- <img src="@/assets/images/m/downloads.png" alt="">  -->
      <a @click="downloadMobile" class="download-btn">点击下载客户端</a>
    </div>

  </div>
</template>

<script>
export default {
  name: "MDownload",
  data() {
    return {
      isWX: false
    };
  },
  methods: {
    wxshare(t,d){
      let sharelink = window.location.href;
      let sharetitle = t +'-大河网';
      let shareimgUrl = 'https://4g.dahe.cn/resources/img/wxlogo1.png';
      let sharedes = d;

      let result = fetch("https://share.dahe.cn/share/yanyu?url=" + encodeURIComponent(sharelink));
      result.then(function(response) {
          return response.json()
      }).then(function(data) {
          let text = data.object;

          /* 微信 */
          wx.config({
              debug: false, // 开启调试模式。
              appId: text.appId, // 必填，公众号的唯一标识
              timestamp: text.timestamp, // 必填，生成签名的时间戳
              nonceStr: text.nonceStr, // 必填，生成签名的随机串
              signature: text.signature, // 必填，签名
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
          });

          wx.checkJsApi({
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function(res) {
                  // console.log(res)
              }
          });

          //需在用户可能点击分享按钮前就先调用
          wx.ready(function() {

              // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
              wx.updateAppMessageShareData({
                  title: sharetitle, // 分享标题
                  link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: shareimgUrl, // 分享图标
                  desc: sharedes, // 分享描述
                  success: function() {
                      // 设置成功
                  }
              })

              // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
              wx.updateTimelineShareData({
                  title: sharetitle, // 分享标题
                  link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: shareimgUrl, // 分享图标
                  success: function() {
                      // 设置成功
                  }
              })
          });

          wx.error(function(res) {
              console.log("err: " + res)
                  // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
      }).catch(function(ex) {
          console.log('failed', ex)
      })
    },
    downloadMobile(){
      var u = navigator.userAgent;
      var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      // 微信内
      if (isWeixin) {
          alert('请在浏览器中打开')
      } else {
          //android端
          if (isAndroid) {
              //安卓app的scheme协议
              window.location.href = 'https://bbs.dahe.cn/app/dahewang.apk';
              setTimeout(function () {
                  let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                  if (typeof hidden == "undefined" || hidden == false) {
                      //应用宝下载地址 (emmm 找不到淘宝应用宝的地址，这里放的是 lucky coffee 地址)
                      window.location.href = "https://bbs.dahe.cn/app/dahewang.apk ";
                  }
              }, 2000);
          }
          //ios端
          if (isIOS) {
              //ios的scheme协议
              window.location.href = 'YanYu://'
              setTimeout(function () {
                  let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                  if (typeof hidden == "undefined" || hidden == false) {
                      //App store下载地址
                      window.location.href = "https://apps.apple.com/us/app/大河网/id1172258000";
                  }
              }, 2000);
          }
      }
    },
    //判断环境
    getEnv(){
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWX = true;
      }else{
        this.isWX = false;
      }
    },

  },
  created() {
    this.getEnv();
    this.wxshare('大河网APP','河南政务信息权威发布');
  }
};
</script>

<style scoped lang="scss">
.m-box {
  position: absolute;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  background:url("../../assets/images/m/downloads.png") top -100px  center  no-repeat;
  background-size: 100%;
  .download-tips{
    width: 100%;
    padding: 10px 30px;
    color: #333;
    background: #D8EBFF url("../../assets/images/m/download_tips.png") right 25px top 15px no-repeat;
    background-size: 52px 35px;
    b{
      font-weight: bolder;
      font-size: 24px;
      margin-right: 19px;
      line-height: 2;
      margin-left: 5px;
      vertical-align: middle;
    }
    p{
      font-size: 13px;
      font-weight: 500;
    }
  }
  .downlaod-main{
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -116px;
    img{
      width: 215px;
      display: block;
      height: auto;
      margin: 0 auto;
    }
    a{
      display: block;
      width: 232px;
      margin: 20vw auto 0;
      text-align: center;
      color: #fff;
      font-size: 17px;
      height: 52px;
      line-height: 52px;
      background: #317DFF;
      border-radius: 25px;
    }
  }

}
@media screen and (min-width: 751px){
  .m-box{
    left: 50%;
    margin-left: -375px;
    background: #F1F6FF  center top 70vh no-repeat;
    .downlaod-main{
      margin-top: 15vh;
      a{
        margin-top: 10vh;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/m/Download.vue